import { ColorOptions, required } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import * as Yup from 'yup'

const optionalOrMaxFifty = Yup.string()
  .max(50, 'Max allowed length is 50')
  .matches(/(^$)|(^[a-zA-Z0-9]+$)/, 'Only alphanumeric chars allowed')

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

export const formData: any = (isEditable: boolean) => [
  {
    formItems: [
      {
        fieldName: 'merchantId',
        ComponentName: TextInputNew,
        label: 'Merchant Id*',
        placeholder: 'Merchant Id',
        validationSchema: required,
        editable: isEditable,
        ...textinputStyle,
      },
      {
        fieldName: 'ledgerAcctNumber',
        ComponentName: TextInputNew,
        label: 'Ledger Account Number',
        placeholder: 'Ledger Account Number',
        validationSchema: required,
        editable: isEditable,
        ...textinputStyle,
      },
    ],
    onSubmit: () => {
      return ''
    },
    actionTitle: 'Add Mapping',
  },
]
